var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98999 15.35H0.75",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 15.35C18.99 15.9196 18.8211 16.4764 18.5046 16.95C18.1882 17.4236 17.7383 17.7928 17.2121 18.0108C16.6858 18.2288 16.1068 18.2858 15.5481 18.1747C14.9895 18.0636 14.4763 17.7893 14.0735 17.3865C13.6708 16.9837 13.3964 16.4706 13.2853 15.9119C13.1742 15.3532 13.2312 14.7741 13.4492 14.2478C13.6672 13.7216 14.0363 13.2718 14.5099 12.9554C14.9835 12.6389 15.5404 12.47 16.11 12.47C16.4882 12.47 16.8627 12.5445 17.2121 12.6892C17.5615 12.834 17.879 13.0461 18.1465 13.3135C18.4139 13.5809 18.626 13.8984 18.7707 14.2478C18.9155 14.5973 18.99 14.9718 18.99 15.35V15.35Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 3.63004H18.99",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.63004C0.75 4.19965 0.918893 4.75641 1.23535 5.23002C1.55181 5.70363 2.00164 6.07283 2.52789 6.29081C3.05414 6.50879 3.63317 6.56575 4.19183 6.45463C4.7505 6.3435 5.26367 6.0692 5.66644 5.66642C6.06922 5.26364 6.34353 4.75048 6.45465 4.19181C6.56578 3.63315 6.50875 3.05412 6.29077 2.52787C6.07279 2.00162 5.70366 1.55185 5.23004 1.23539C4.75643 0.918931 4.19962 0.750038 3.63 0.750038C3.2518 0.750038 2.87731 0.824543 2.52789 0.969276C2.17848 1.11401 1.86094 1.32611 1.59351 1.59354C1.32607 1.86098 1.11397 2.17845 0.969238 2.52787C0.824505 2.87729 0.75 3.25184 0.75 3.63004V3.63004Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.19114b5668054d640b56dc70334d3cb5.svg";
export { ForwardRef as ReactComponent };